<template>
  <ThemeECommerceContainerSection
    :title="modelValue.title"
    :description="modelValue.description"
    class="tw-bg-light-gray-1"
    :see-more-path="getPath({ componentName: 'Article' })"
    :menu-code="MENU_CODE.ARTICLE"
    category-event-name="categoryEventName"
    :event-name="eventName"
  >
    <div
      class="tw-flex tw-overflow-x-auto tw-scrollbar-hide md:tw-grid md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 md:tw-gap-6 tw-pb-4 md:tw-pb-0 tw-px-4 md:tw-px-0 -tw-mx-4 md:tw-mx-0"
    >
      <ThemeECommerceCardArticle
        v-for="item in modelValue.content"
        :key="`article-${item._id}`"
        title-tag="h3"
        class="tw-min-w-[60vw] tw-max-w-[340px] md:tw-min-w-0 md:tw-max-w-none tw-mb-2"
        :published-at="item.publishedAt"
        :image="item.imageCover"
        :title="item.title"
        :description="item.shortDescription"
        :category="item.articleCategory"
        :path="getPath({ componentName: 'Article', slug: item.slug })"
        @click="eventHomeArticle(item.title)"
      />
    </div>
  </ThemeECommerceContainerSection>
</template>

<script lang="ts" setup>
defineProps({
  modelValue: {
    type: Object as () => HomeSection<Article[]>,
    required: true,
  },
});
const { MENU_CODE, eventName, eventHomeArticle, getPath } = useArticleSection();
</script>

<style scoped>
.tw-scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tw-scrollbar-hide::-webkit-scrollbar {
  display: none;
}
</style>
